var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "walett"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/wallet-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclude",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8589 10.9274C18.3744 11.4004 18.0975 12.081 18.1667 12.8079C18.2705 14.0538 19.4127 14.9652 20.6586 14.9652H22.9199V16.6381C22.9199 20.0991 20.6125 22.4065 17.1515 22.4065H6.76838C3.30735 22.4065 1 20.0991 1 16.6381V8.56233C1 5.42433 2.89203 3.23234 5.83391 2.86316C6.13387 2.81702 6.44536 2.79395 6.76838 2.79395H17.1515C17.4514 2.79395 17.7399 2.80547 18.0167 2.85162C20.9932 3.19772 22.9199 5.40126 22.9199 8.56233V10.2352H20.5202C19.8741 10.2352 19.2858 10.489 18.8589 10.9274ZM20.5203 11.7349H22.5736V13.4649H20.6587C20.0745 13.4649 19.6913 13.0389 19.6616 12.683L19.66 12.6653C19.636 12.4131 19.7301 12.1728 19.9068 12.0004C19.9158 11.9915 19.9248 11.9826 19.9337 11.9735C20.0762 11.8271 20.2761 11.7349 20.5203 11.7349ZM6.76758 8.38916C6.35336 8.38916 6.01758 8.72495 6.01758 9.13916C6.01758 9.55337 6.35336 9.88916 6.76758 9.88916H13.6896C14.1039 9.88916 14.4396 9.55337 14.4396 9.13916C14.4396 8.72495 14.1039 8.38916 13.6896 8.38916H6.76758Z",
    fill: "#6C84F8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.af07eba45af1e158c6af5275affc4a14.svg";
export { ForwardRef as ReactComponent };